
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","viewBox":"0 0 80 80","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.526 48.004a5.122 5.122 0 01-.498.3c-.312.182-.992.02-2.038-.489-.48-.238-.744-.46-3.63-3.112-1.502-1.267-2.617-2.289-3.347-3.066-.564-.602-.928-1.02-1.09-1.253a1.412 1.412 0 01-.2-.805c.02-.433.213-.82.576-1.161.424-.398.903-.585 1.437-.562.36.02.687.14.98.362.323.222 1.01.833 2.06 1.832l.743.715c1.29 1.247 2.823 2.727 3.836 3.453l.08.057.167-.144c1.135-.976 9.569-9.302 10.842-10.757.96-1.088 1.59-1.757 1.891-2.006.273-.246.588-.395.945-.447.53-.07 1.023.074 1.48.433.393.308.618.676.677 1.106.04.286-.004.56-.129.82-.14.247-.466.695-.975 1.343-.658.839-1.68 1.955-3.063 3.35-8.614 8.504-9.535 9.34-9.992 9.62a9.37 9.37 0 01-.752.411z"}})])
          )
        }
      }
    